import { Download, RefreshCw, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { usePwa } from './PwaProvider';

export function PwaPrompts() {
  const { t } = useTranslation();
  const { offlineReady, updateAvailable, applyUpdate, dismissUpdate } = usePwa();

  if (!offlineReady && !updateAvailable) return null;

  return (
    <aside className="toast-region" aria-live="polite" aria-atomic="true">
      {offlineReady && !updateAvailable && (
        <div className="toast">
          <Download size={19} aria-hidden="true" />
          <span>{t('offline.readiness.coreReady')}</span>
          <span className="status-pill" data-tone="positive">{t('offline.readiness.ready')}</span>
        </div>
      )}
      {updateAvailable && (
        <div className="toast">
          <RefreshCw size={19} aria-hidden="true" />
          <span><strong>{t('offline.update.available')}</strong><br />{t('offline.update.description')}</span>
          <span>
            <button className="button" type="button" onClick={() => void applyUpdate()}>{t('offline.update.reload')}</button>
            <button className="icon-button" type="button" onClick={dismissUpdate} aria-label={t('offline.update.later')}><X size={17} /></button>
          </span>
        </div>
      )}
    </aside>
  );
}
